import {
	includedPropList,
	includedT2PropList,
} from "../../../pages/activityBuilder/modules/otherLand/otherLand";
import type {
	OtherLandResponse,
	ModuleFull,
} from "../../../pages/activityBuilder/modules/otherLand/otherLandTypes";
import { FEModules } from "../../../utils/moduleList";
import { FEModulesObj } from "../../../utils/moduleList";
import { apiSlice, publicApiSlice, TagTypes } from "../../apiSlice";
import { createModuleGetApi, createModuleUpdateApi } from "./factories/createModuleApi";
import { transformModuleResponse, prepareModulePayload } from "./factories/moduleApiUtils";

// Define constants for the module
const MODULE_TYPE = "OtherLand";
const TAG: TagTypes = "OtherLand";
const TAG_DEFAULTS: TagTypes = "OtherLandDefaults";
const ENDPOINT = FEModulesObj[FEModules.OtherLand].path;

const transformResponse = (response: OtherLandResponse) => transformModuleResponse<OtherLandResponse, ModuleFull>({
	response,
	includedPropList,
	includedT2PropList
})

const otherLandApiSlice = createModuleGetApi<ModuleFull>({
	apiSlice,
	path: ENDPOINT,
	moduleName: MODULE_TYPE,
	tag: TAG,
	tagDefaults: TAG_DEFAULTS,
	transformResponse,
})

const publicOtherLandApiSlice = createModuleGetApi<ModuleFull>({
	apiSlice: publicApiSlice,
	path: ENDPOINT,
	moduleName: MODULE_TYPE,
	tag: TAG,
	tagDefaults: TAG_DEFAULTS,
	transformResponse,
})

const transformUpdatePayload = (data: ModuleFull, activityId: number) => prepareModulePayload({
	moduleData: data.module,
	tiertwoData: data.tiertwo,
	activityId
})

const mutationApiSlice = createModuleUpdateApi<ModuleFull, OtherLandResponse>({
	apiSlice,
	path: ENDPOINT,
	moduleName: MODULE_TYPE,
	tag: TAG,
	tagDefaults: TAG_DEFAULTS,
	transformUpdatePayload,
	includesLandUseChange: true
})

export const {
	useGetOtherLandQuery,
	useGetOtherLandDefaultsQuery
} = otherLandApiSlice;

export const {
	useGetOtherLandQuery: usePublicGetOtherLandQuery,
	useGetOtherLandDefaultsQuery: usePublicGetOtherLandDefaultsQuery
} = publicOtherLandApiSlice;

export const {
	useUpdateOtherLandMutation,
} = mutationApiSlice;
